import { Spin, Tag, Tooltip } from 'antd';
import { FC, memo } from 'react';
import { DatabaseFillCheck, DatabaseFillExclamation, DatabaseFillGear, DatabaseFillX } from 'react-bootstrap-icons';
import { ProxyServerAddress } from '../../entities';
import { ProxyServerConfigurationStatuses } from '../../proxyServerAddresses.interfaces';

interface Props {
  configurationStatus: ProxyServerAddress['configurationStatus'];
  simple?: boolean;
}

export const ProxyServerAddressesConfigTag: FC<Props> = memo(({ configurationStatus, simple = false }) => {
  const text = simple ? '' : <>Проксі для запитів:&nbsp;</>;

  if (configurationStatus === ProxyServerConfigurationStatuses.NotConfigured) {
    return (
      <Tooltip title="не налаштовано">
        <Tag color="error" bordered={ !simple }>
          { text }
          <DatabaseFillX/>
        </Tag>
      </Tooltip>
    );
  }

  if (configurationStatus === ProxyServerConfigurationStatuses.Configurating) {
    return (
      <Tooltip title="налаштування">
        <Tag color="processing" bordered={ !simple }>
          { text }
          <DatabaseFillGear/>
        </Tag>
      </Tooltip>
    );
  }

  if (configurationStatus === ProxyServerConfigurationStatuses.Configured) {
    return (
      <Tooltip title="налаштовано">
        <Tag color="success" bordered={ !simple }>
          { text }
          <DatabaseFillCheck/>
        </Tag>
      </Tooltip>
    );
  }

  if (configurationStatus === ProxyServerConfigurationStatuses.Unknown) {
    return (
      <Tooltip title="невідомо">
        <Tag color="default" bordered={ !simple }>
          { text }
          <DatabaseFillExclamation/>
        </Tag>
      </Tooltip>
    );
  }

  if (configurationStatus === ProxyServerConfigurationStatuses.Checking) {
    return (
      <Tooltip title="перевірка">
        <Tag color="geekblue" bordered={ !simple }>
          { text }
          <Spin size="small" spinning/>
        </Tag>
      </Tooltip>
    );
  }
});
